import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import TableSearch from '../components/TableSearch'
import { makeGetData } from '../selectors/dataSelector'
import getFeaturesFromGeoJson from '../utility/getFeaturesFromGeoJson'
import MapActions from '../redux/mapRedux'

class Table extends PureComponent {
  handleClick = (row, cell, event) => {
    const { actions } = this.props

    const center = row.slice(row.length - 2, row.length)
    const zoom = [15]

    actions.centerZoomChanged(center, zoom)
  }

  render() {
    const { data } = this.props
    if (!data) {
      return null
    }

    return (
      <TableSearch data={data} onClick={this.handleClick} />
    )
  }
}

const makeMapStateToProps = (state, ownprops) => {
  const { id } = ownprops
  
  const getData = makeGetData()

  const mapStateToProps = state => {
    return {
      data: getData(state, id, getFeaturesFromGeoJson),
    }
  }
  return mapStateToProps
}

const mapDispatchToProps = dispatch => {
  return {
    actions: {
      centerZoomChanged: (center, zoom) => {
        dispatch(MapActions.centerZoomChanged(center, zoom))
      }
     }
  }
}

export default connect(makeMapStateToProps, mapDispatchToProps)(Table)



// WEBPACK FOOTER //
// ./src/containers/Table.js